export enum LicenseExceptions {
  NO_INFO = 0,
  NO_CONNECTION = 1,
  IS_ADDON = 2,
  ALREADY_IN_USE = 3,
  DOES_NOT_HAVE_BASE_LICENSE = 4,
  DEPENDENT_LICENSE_MISSING = 5,
  DOES_NOT_HAVE_RM_BASE_LICENSE = 6,
  TEMPLATE_DISABLED = 7,
}
